import { graphql } from '@/gql'

export const FROALA_STYLE = graphql(`
  query froalaStyleById($id: UUID!) {
    froalaStyleById(id: $id) {
      ...FroalaStyle
    }
  }
`)

export const FROALA_STYLES = graphql(`
  query froalaStyles(
    $first: Int
    $last: Int
    $before: Cursor
    $after: Cursor
    $orderBy: [FroalaStylesOrderBy!]
    $filter: FroalaStyleFilter
    $companyId: UUID
  ) {
    froalaStyles(
      first: $first
      last: $last
      before: $before
      after: $after
      orderBy: $orderBy
      filter: $filter
      condition: { active: true, companyId: $companyId }
    ) {
      edges {
        node {
          ...FroalaStyle
        }
      }
    }
  }
`)
